import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { faSpinner, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiPrefixService, YardiCommonModule, YardiToasterService } from 'yardi-angular-framework-bootstrap';

@Component({
  standalone: true,
  imports: [YardiCommonModule],
  selector: 'user-info-company-modal',
  templateUrl: './user-info-company-modal.component.html',
  styleUrls: ['./user-info-company-modal.component.scss']
})
export class UserInfoCompanyModalComponent implements OnInit {
  @Input() ShareObj: any;

  isSaving = false;
  CompaniesList: any[] = [];
  faTimes = faTimes;
  faSpinner = faSpinner;

  constructor(
    private activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private apiPrefix: ApiPrefixService,
    private http: HttpClient,
    private toaster: YardiToasterService,
  ) { }

  ngOnInit(): void {
    if (this.ShareObj) {
      this.CompaniesList = this.ShareObj.CompaniesList || [];
    }
  }

  /**
   * Closes the modal with success result
   */
  ok(): void {
    this.activeModal.close(true);
  }

  /**
   * Cancels the modal operation
   */
  cancel(): void {
    this.activeModal.close({ isSelected: false });
  }

  /**
   * Closes the modal without selection
   */
  close(): void {
    this.activeModal.close({ isSelected: false });
  }

  /**
   * Selects a company and closes the modal with the selected company data
   * @param company - The selected company object
   */
  selectCompany(company: any): void {
    //this.activeModal.close({ isSelected: true, company: company });
    this.isSaving = true;
    this.doCompanyLogin(company);

  }

  doCompanyLogin(data) {
    // Example user email
    // let userEmail = data.company.username;

    // // Encode the email to make it URL-safe
    // let encodedEmail = encodeURIComponent(userEmail);
    let domain = data.domain;
    // // URL with parameter
    // let url = "http://" + domain + ".investorportal.com:5000/content2/access/companylogin?id=" + encodedEmail;

    // // Open in a new window/tab
    // window.open(url, "_self");
    let baseURL1 = this.apiPrefix.rootPath ? this.apiPrefix.rootPath + 'portaluser/getcompanyloginlink' : 'api/portaluser/getcompanyloginlink';

    this.http.get<any>(`${baseURL1}`, {
      params: new HttpParams().set('sdomain', domain)
    })
      .subscribe({
        next: (response: any) => {
          let hm = response
          // Open in a new window/tab
          window.localStorage.clear();
          window.sessionStorage.clear();
          window.open(response.MagicLink, "_self");
          // if (response.headers("userexist") !== undefined && response.headers("userexist") === "false") {
          //   this.toaster.error("", "Your user account has not been registered for access. Please contact your site administrator for registration.");
          // } else {
          //   this.toaster.success("", "We've sent you a login link to access the Investor Portal. Please check your email and click the Sign In link to proceed");
          // }
        },
        error: (err: any) => {
          if (typeof err === 'string') {
            //this.toaster.error("", err);
          }
        },
        complete: () => { }
      });

  }

}
